import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { CometStar } from './BrandArtwork';
import { HeroBackgroundVideo } from './HeroBackgroundVideo';
import { principles } from '../data/site';
export function Hero() {
  return <section id="top" className="bg-ink" data-id="element-37" data-mp="9lbhp5hdljfp">
      <div className="relative min-h-[780px] overflow-hidden md:min-h-[640px] lg:min-h-[700px]" data-id="element-38" data-mp="4lqjwydxzh4k">
        <HeroBackgroundVideo data-id="element-39" data-mp="129h21r4ip6f0" />

        <div className="relative z-10 mx-auto flex min-h-[780px] max-w-content flex-col justify-start px-5 pb-24 pt-14 sm:px-6 md:min-h-[640px] md:justify-center md:px-8 md:py-24 lg:min-h-[700px] lg:px-10" data-id="element-40" data-mp="129qvjoortvpg">
          <div className="max-w-[650px]" data-id="element-41" data-mp="sa9rtct2xrw4">
            <p className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.22em] text-cream/70" data-id="element-42" data-mp="sddz4j1ud3r0">
              <CometStar className="h-2.5 w-2.5 text-gold" data-id="element-43" data-mp="3d1ihv20l0yjq" />
              Boutique app studio
            </p>

            <h1 className="mt-7 font-display text-[40px] font-semibold leading-[1.04] tracking-[-0.025em] text-cream sm:text-[56px] lg:text-[66px]" data-id="element-44" data-mp="381xmf1kmf8br">
              Small studio.
              <br data-id="element-45" data-mp="3o7lshs6gf8ph" />
              <span className="text-violet" data-id="element-46" data-mp="3o85b7b3xi14k">
                Serious apps
                <span className="text-gold" data-id="element-47" data-mp="3o59cvlo65afl">.</span>
              </span>
            </h1>

            <p className="mt-7 max-w-lg text-[17px] leading-relaxed text-cream/80" data-id="element-48" data-mp="39cfkx0rpn1u1">
              Black Comet Labs builds original apps for learning, life and play. A focused
              portfolio. High standards. Plenty of personality.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-6" data-id="element-49" data-mp="359szpipjof5t">
              <a href="#lab" className="inline-flex min-h-[52px] items-center gap-2 rounded-[2px] bg-violet px-7 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-violet/85" data-id="element-50" data-mp="2qk3m2o09mion">
                Explore the lab
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="2lkqy1zxnr5kh" />
              </a>
              <a href="#story" className="inline-flex min-h-[44px] items-center border-b border-cream/40 text-[15px] font-medium text-cream/90 transition-colors duration-150 ease-out hover:border-cream hover:text-cream" data-id="element-52" data-mp="2lml98mj4njbd">
                The studio
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-cream/15" data-id="element-53" data-mp="deq40266mfw6">
        <dl className="mx-auto grid max-w-content grid-cols-1 gap-px bg-cream/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-54" data-mp="1b0nmw0oh4n8n">
          {principles.map(principle => <div key={principle.title} className="bg-ink px-5 py-9 md:px-8 lg:px-10" data-id="element-55" data-mp="162m3tfr1snx6">
              <dt className="font-display text-[26px] font-medium leading-none text-cream md:text-[28px]" data-id="element-56" data-mp="11151rgwtuvf0">
                {principle.title}
              </dt>
              <dd className="mt-3 text-[14px] leading-relaxed text-cream/60" data-id="element-57" data-mp="3ltgoxvs8x0qz">{principle.caption}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}